module.exports = __webpack_public_path__ + "static/img/campoco-2.4d51966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/campoco-2.jpg
// module id = 0tt4
// module chunks = 1